module.exports = __webpack_public_path__ + "static/img/enfei-new.14eeaa2d.png";